import Api from "@/api";

export type { CrmContact } from "@/api";

export const getCrmContacts = Api.crmContacts.list;
export const useGetCrmContacts = Api.crmContacts.useList;
export const useCreateCrmContact = Api.crmContacts.useCreate;
export const useUpdateCrmContact = Api.crmContacts.useUpdate;

export type CrmStatus = "lead" | "contacted" | "qualified" | "customer" | "lost";

export const CRM_STATUSES: CrmStatus[] = ["lead", "contacted", "qualified", "customer", "lost"];

/**
 * The contacts tool ships in every space. A space that reads as a sales context
 * (its name contains the word "Sales") presents it as a full "CRM"; every other
 * space gets the same tool under the friendlier name "Saved Contacts".
 */
export function crmToolLabel(spaceName?: string | null): string {
  return /\bsales\b/i.test(spaceName ?? "") ? "CRM" : "Saved Contacts";
}

export function isSalesSpace(spaceName?: string | null): boolean {
  return crmToolLabel(spaceName) === "CRM";
}
